import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import 'animate.css'
import './assets/css/global.css'
import $utils from './utils/index.js'
import Swiper from 'swiper'
import 'swiper/css/swiper.css' // 5.x 专用样式

Vue.use(ElementUI)
Vue.prototype.$utils = $utils
Vue.prototype.$axios = axios
Vue.prototype.$Swiper = Swiper
Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_URL
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')